export default __webpack_public_path__ + "static/media/4.31b69232.jpg";